import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useInsiderMembershipInvoiceDownload } from "@faire/retailer-visitor-shared/components/InsiderBillingHistoryModal/useInsiderMembershipInvoiceDownload";
import { InsiderLabelWithIcon } from "@faire/retailer-visitor-shared/components/InsiderLabel/InsiderLabelWithIcon";
import { intlDate } from "@faire/web--source/common/localization/date-fns/intlDate";
import { moneyOrZero } from "@faire/web--source/common/money";
import { MoneyMath } from "@faire/web--source/common/MoneyMath";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Modal } from "@faire/web--source/slate/Modal";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Money } from "@faire/web--source/ui/Money";
import { useQuery as useInsiderMembershipInvoicesQuery } from "@faire/web-api--source/api/membership/membership-invoices/get-hooks";
import React from "react";
import styled from "styled-components";
export var InsiderBillingHistoryModal = function(param) {
    var onClose = param.onClose;
    var _data_insider_membership_invoices;
    var _useInsiderMembershipInvoicesQuery = useInsiderMembershipInvoicesQuery(), data = _useInsiderMembershipInvoicesQuery.data, isPending = _useInsiderMembershipInvoicesQuery.isPending;
    var _useInsiderMembershipInvoiceDownload = useInsiderMembershipInvoiceDownload(), isDownloadingInvoice = _useInsiderMembershipInvoiceDownload.isLoading, downloadingInvoiceToken = _useInsiderMembershipInvoiceDownload.downloadingInvoiceToken, downloadInvoice = _useInsiderMembershipInvoiceDownload.downloadInvoice;
    var _data_insider_membership_invoices_map;
    return /*#__PURE__*/ _jsx(Modal, {
        justify: "center",
        height: "465px",
        padding: getSpacing(0, "3x"),
        onClose: onClose,
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "10x"
                }),
                /*#__PURE__*/ _jsx(InsiderLabelWithIcon, {
                    reverseIcon: true
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "pageHeaderSerifRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "g6+rWh",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Membership billing history"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "4x"
                }),
                /*#__PURE__*/ _jsx(Content, {
                    children: isPending ? /*#__PURE__*/ _jsx(LoadingSpinner, {}) : (_data_insider_membership_invoices_map = data === null || data === void 0 ? void 0 : (_data_insider_membership_invoices = data.insider_membership_invoices) === null || _data_insider_membership_invoices === void 0 ? void 0 : _data_insider_membership_invoices.map(function(invoice) {
                        return /*#__PURE__*/ _jsx(InvoiceItem, {
                            membershipInvoice: invoice,
                            onDownloadClick: downloadInvoice,
                            isLoading: isDownloadingInvoice && invoice.token === downloadingInvoiceToken
                        }, invoice.token);
                    })) !== null && _data_insider_membership_invoices_map !== void 0 ? _data_insider_membership_invoices_map : null
                })
            ]
        })
    });
};
var InvoiceItem = function(param) {
    var membershipInvoice = param.membershipInvoice, onDownloadClick = param.onDownloadClick, isLoading = param.isLoading;
    var tax = moneyOrZero(membershipInvoice.tax);
    var _membershipInvoice_membership_payment_date;
    return /*#__PURE__*/ _jsxs(Item, {
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansMedium",
                        children: intlDate((_membershipInvoice_membership_payment_date = membershipInvoice.membership_payment_date) !== null && _membershipInvoice_membership_payment_date !== void 0 ? _membershipInvoice_membership_payment_date : new Date(), "PP")
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsxs(Typography, {
                        color: Core.text.subdued,
                        children: [
                            /*#__PURE__*/ _jsx(Money, {
                                money: moneyOrZero(membershipInvoice.sub_total)
                            }),
                            MoneyMath.notEqualToZero(tax) ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    "\xa0(+",
                                    /*#__PURE__*/ _jsx(Money, {
                                        money: tax
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "TB0AYg",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "VAT"
                                            }
                                        ]
                                    }),
                                    ")"
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                onClick: function() {
                    return onDownloadClick(membershipInvoice);
                },
                children: isLoading ? /*#__PURE__*/ _jsx(LoadingSpinner, {
                    size: "small"
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "QOsBCh",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Download"
                        }
                    ]
                })
            })
        ]
    });
};
var Wrapper = styled(Column).withConfig({
    componentId: "sc-afddfd00-0"
})([
    "overflow:hidden;width:100%;height:100%;"
]);
var Content = styled(Column).attrs({
    flex: 1
}).withConfig({
    componentId: "sc-afddfd00-1"
})([
    "width:100%;overflow:auto;margin:",
    ";padding:",
    ";"
], getSpacing(0, "-1x", 0, 0), getSpacing(0, "1x", 0, 0));
var Item = styled(Row).attrs({
    align: "center",
    justify: "space-between"
}).withConfig({
    componentId: "sc-afddfd00-2"
})([
    "height:52px;padding:",
    ";border-top:1px solid ",
    ";"
], getSpacing("2x", 0), Core.border.muted);
